<template>
  <footer :class="footer_class">
    <div class="container-fluid">
      <div class="row">
        <div class="col py-2 text-center text-white">MFJ manage system</div>
      </div>
    </div>
  </footer>
</template>
<style>
.footer {
  z-index: 9999 !important;
  width: 100% !important;
  position: relative !important;
  flex-shrink: 0 !important;
  background-color: #343a40 !important;
  height: 40px !important;
  min-height: 40px !important;
  display: flex !important;
  align-items: center !important;
  margin-top: auto !important; /* コンテンツが少ない場合に下部に配置 */
}

.not-footer {
  /* 必要に応じてスタイルを追加 */
}

.container-fluid {
  width: 100% !important;
}
</style>
<script>
// import Vue from 'vue'

import { mapState } from 'vuex'
export default {
  name: 'BsFooterView',
  data: function () {
    return {
      disp_note: false,
      disp_jancode: false
      //   count: this.$store.state.count
    }
  },
  props: {
    front_view: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({}),
    footer_class() {
      if (this.front_view) {
        return 'not-footer'
      }
      return 'footer bg-dark'
    }
  },
  components: {},
  methods: {}
}
</script>
